import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const AuditoryRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle
          cx='4'
          cy='4'
          r='3.25'
          transform='matrix(-1 0 0 1 22 8)'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M7.52575 2.27466C7.15954 1.90845 6.56579 1.90845 6.19957 2.27466C3.71167 4.76257 2.1712 8.20228 2.1712 12C2.1712 15.7977 3.71167 19.2374 6.19957 21.7253C6.56579 22.0916 7.15954 22.0916 7.52575 21.7253C7.89197 21.3591 7.89197 20.7654 7.52575 20.3992C5.37519 18.2486 4.04671 15.2803 4.04671 12C4.04671 8.71967 5.37519 5.7514 7.52575 3.60084C7.89197 3.23463 7.89197 2.64088 7.52575 2.27466Z'
          fill='currentColor'
        />
        <path
          d='M10.3992 6.47501C10.7654 6.1088 11.3591 6.1088 11.7253 6.47501C12.0916 6.84123 12.0916 7.43498 11.7253 7.80119C10.6495 8.87699 9.98582 10.3605 9.98582 12.0008C9.98582 13.6411 10.6495 15.1246 11.7253 16.2004C12.0916 16.5666 12.0916 17.1603 11.7253 17.5265C11.3591 17.8927 10.7654 17.8927 10.3992 17.5265C8.98602 16.1134 8.11031 14.1585 8.11031 12.0008C8.11031 9.84309 8.98602 7.88815 10.3992 6.47501Z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <circle
          cx='4'
          cy='4'
          r='4'
          transform='matrix(-1 0 0 1 22 8)'
          fill='currentColor'
        />
        <path
          d='M7.52575 2.27466C7.15954 1.90845 6.56579 1.90845 6.19957 2.27466C3.71167 4.76257 2.1712 8.20228 2.1712 12C2.1712 15.7977 3.71167 19.2374 6.19957 21.7253C6.56579 22.0916 7.15954 22.0916 7.52575 21.7253C7.89197 21.3591 7.89197 20.7654 7.52575 20.3992C5.37519 18.2486 4.04671 15.2803 4.04671 12C4.04671 8.71967 5.37519 5.7514 7.52575 3.60084C7.89197 3.23463 7.89197 2.64088 7.52575 2.27466Z'
          fill='currentColor'
        />
        <path
          d='M10.3992 6.47501C10.7654 6.1088 11.3591 6.1088 11.7253 6.47501C12.0916 6.84123 12.0916 7.43498 11.7253 7.80119C10.6495 8.87699 9.98582 10.3605 9.98582 12.0008C9.98582 13.6411 10.6495 15.1246 11.7253 16.2004C12.0916 16.5666 12.0916 17.1603 11.7253 17.5265C11.3591 17.8927 10.7654 17.8927 10.3992 17.5265C8.98602 16.1134 8.11031 14.1585 8.11031 12.0008C8.11031 9.84309 8.98602 7.88815 10.3992 6.47501Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
